import { gql } from "graphql-request";

export const GET_DASHBOARD_UPDATE_DATE = gql`
  query DataLastUpdate($params: DastLastUpdateInput) {
    dataLastUpdate(params: $params) {
      data {
        lastUpdatedAt
      }
    }
  }
`;

export * from "./potential";
export * from "./visibility";
